<template>

    <m-edit1/>

    <m-Alert-1 v-bind='{...{},...{}}' :style='""' class="col-11 mx-auto mt-2 text-center" >
                <template #default>(ارسال بصورت پس کرایه می باشد)   </template>
                </m-Alert-1><m-un-authenticated-shopping-cart2 v-bind='{...{"EmptyCartImage":null,"instagramProp":false,"hideAddressDescription":true,"hideSignupButton":true,"presenterProp":false,"order_description_prop":true,"postal_code_prop":true,"codeMeliProp":false,"gradeProp":false,"orientationProp":false,"schoolNameProp":false,"classNameProp":false,"birthdayProp":false,"motherJobProp":false,"fatherJobProp":false,"registerRequestProp":false,"gradeSelectProp":false,"roundTripServiceProp":false,"shiftProp":false,"deliveryNewAddressProp":true,"deliveryDefaultAddressProp":false,"hideRefreshShoppingCartButton":true,"defaultGate":null,"activeShoppingCartForm":false,"addressRequired":true,"setUnauthenticatedShoppingCartFromLoginUser":false,"advanceDescriptionInputs":"","advanceDescription":false,"showProductListProp":true,"orderDescriptionValueProp":"","disableSelectedCityWatch":true,"defaultLocation":true,"defaultCityId":"","defaultProvinceId":"","deliveryOptionStyle":"select-box"},...{}}' :style='""' class="my-5" >
                <template #default>default   </template>
                </m-un-authenticated-shopping-cart2>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mAlert1 from '@moeinmdn/miw-alpha-components/src/package/Alert/Alert1'; import mUnAuthenticatedShoppingCart2 from '@moeinmdn/miw-alpha-components/src/package/UnAuthenticatedShoppingCart/UnAuthenticatedShoppingCart2';

export default {
    name: 'HomeView',
    components: {mEdit1, mAlert1,mUnAuthenticatedShoppingCart2 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
